import InnerImageZoom from "vue-inner-image-zoom/lib/vue-inner-image-zoom.common.js";

InnerImageZoom.methods.handleMouseLeave = (e) => {
    // Do nothing. Original version will cancel zoom on mouse leave.
};

export default InnerImageZoom;